'use strict';
import jwtDecode from 'jwt-decode';
import 'rxjs/add/observable/of';
import {Observable} from 'rxjs/Observable';
import {isCordovaBuild} from '../../config/constants';
import {REFRESH_TOKEN} from '../../config/constants/auth-keys';
import {authCacheService} from '../services/AuthCacheService';


export const MIN = 60 * 1000;
export const HOUR = 60 * MIN;
export const HS256 = 'HS256';
export const RS256 = 'RS256';
export const EXPIRED = '@@token/EXPIRED';
export const EXPIRING = '@@token/EXPIRING';
export const VALID = '@@token/VALID';

/**
 *
 * @param {String} token
 * @return {?String}
 */
export function getTokenStatus(token) {
  if (!token) {
    return null;
  } else {
    try {
      const exp = expiresIn(token);
      if (exp <= 0) {
        return EXPIRED;
      } else if (exp <= (30 * MIN)) { // Normal case
        // } else if (exp <= (72 * HOUR - 5 * MIN)) { // Testing Token expiring soon handling
        return EXPIRING;
      } else {
        return VALID;
      }
    } catch (e) {
      return null;
    }
  }
}

// HACK: Injects service instance. Needs refactor to be an injectable service
export function saveRefreshToken(refreshToken) {
  if (isCordovaBuild()) {
    return authCacheService.setItem(REFRESH_TOKEN, refreshToken);
  } else {
    return Observable.of(null);
  }
}

// HACK: Injects service instance. Needs refactor to be an injectable service
export function loadRefreshToken() {
  if (isCordovaBuild()) {
    return authCacheService.getItem(REFRESH_TOKEN);
  } else {
    return Observable.of(null);
  }
}

// HACK: Injects service instance. Needs refactor to be an injectable service
export function removeRefreshToken() {
  if (isCordovaBuild()) {
    return authCacheService.removeItem(REFRESH_TOKEN);
  } else {
    return Observable.of(null);
  }
}

// START: Methods copied from https://github.com/UXtemple/jwt-auth

export function getExpires(token) {
  // modified to use the fixed version of parsing the token from jwt-decode
  return jwtDecode(token).exp * 1000 || false;
}

export function expiresIn(token) {
  const expires = getExpires(token);
  return expires && expires - Date.now();
}

// END: Methods copied from https://github.com/UXtemple/jwt-auth



// WEBPACK FOOTER //
// ./src/js/auth/utils/token.js